import React from 'react';

// Silhueta do "S" do Showtime para o menu lateral: sem cor própria, segue o fill de .icone-sup svg.
const ShowtimeIconBranco = (props: React.SVGProps<SVGSVGElement>) => (
	<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.3 75.18">
		<path d="M0,52.57l20.2-3.7c1.2,8,6.4,10.8,12.8,10.8,5.7,0,10.4-2.3,10.4-7,0-5.3-5.6-6.6-15.8-9-11.7-2.8-25.7-6.9-25.7-22C1.9,7.57,13.8.07,30.8.07c17.2,0,28.4,8.3,30.2,21l-19.8,2.5c-1.1-6.5-5.2-8.4-10.5-8.4-5.8,0-8.6,2.1-8.6,5.3,0,4.5,3.8,6.1,11.9,8,11.2,2.6,29.3,5,29.3,22.4,0,14.8-12.6,24.31-31.1,24.31C14.3,75.18,1.9,66.27,0,52.57Z" />
	</svg>
);

export default ShowtimeIconBranco;
